import React, { useEffect, useMemo, useState } from "react";
import { Modal, Spinner, Button } from "react-bootstrap";
import { getSFTPEmailLogDetailById } from "../../../../Redux/sftpClient/action";
import DataTable from "react-data-table-component";
import queueDatatableCustomStyles from "../../../../Layout/Elements/QueueDatatableCustomStyles";

const EmailLog = ({ show, onClose, pk }) => {
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [pageno, setPageNo] = useState(1);
    const [limit, setLimit] = useState(100);
    const [loadingRows, setLoadingRows] = useState({});
        const [colorRow, setColorRow] = React.useState({});
    
    


    // Fetch data from API
    const fetchData = async (pk, page = 1, perPage = limit) => {
        if (!pk ||!show) return;

        setLoading(true);
        try {
            getSFTPEmailLogDetailById(pk, page, perPage)(res => {

                if (res?.status && res?.data) {
                    setLogData(res.data.results || []); // Adjust according to API structure
                    setTotalRows(res.data.count || 0);
                } else {
                    setLogData([]);
                    setTotalRows(0);
                }
                setLoading(false);
            }) // Adjust params if needed

        } catch (error) {
            console.error(error);
            setLogData([]);
            setTotalRows(0);
        } finally {
            
        }
    };

    

    const handleDownloadSftpLog = (row, log_record_url = 'log_record_url', isName = false) => {
    // Set this row to loading
    setLoadingRows(prev => ({ ...prev, [row?.id]: true }));

    const fileURL = row?.[log_record_url];
    if (!fileURL) {
        console.error('No file URL found for this row');
        setLoadingRows(prev => ({ ...prev, [row.id]: false }));
        return;
    }

    fetch(fileURL)
        .then(async response => {
            if (!response.ok) throw new Error('Network response was not ok');

            // Determine filename - always extract from URL path
            let filename = 'downloaded_file.log';
            
            // Extract filename from URL path (before query parameters)
            const urlWithoutParams = fileURL.split('?')[0];
            const pathParts = urlWithoutParams.split('/');
            const lastPart = pathParts[pathParts.length - 1];
            
            if (lastPart && lastPart.includes('.')) {
                filename = lastPart;
            }

            // If isName is true and you have a custom extraction function, use it
            if (isName) {
                const { fileName } = extractFileNameAndExtension(fileURL);
                if (fileName) {
                    filename = fileName;
                    // Ensure it has .log extension if missing
                    if (!filename.includes('.')) {
                        filename += '.log';
                    }
                }
            }

            const blob = await response.blob();
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.setAttribute('download', filename);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            
            // Clean up the object URL
            setTimeout(() => {
                window.URL.revokeObjectURL(downloadLink.href);
            }, 100);
        })
        .catch(error => {
            console.error('Error downloading file:', error);
        })
        .finally(() => {
            // Stop loading
            setLoadingRows(prev => ({ ...prev, [row.id]: false }));
        });
};

// Simple function to extract filename from URL
const extractFileNameAndExtension = (url) => {
    try {
        // Remove query parameters first
        const urlWithoutParams = url.split('?')[0];
        // Get the last part of the path
        const pathParts = urlWithoutParams.split('/');
        const fullFileName = pathParts[pathParts.length - 1];
        
        if (fullFileName && fullFileName.includes('.')) {
            const lastDotIndex = fullFileName.lastIndexOf('.');
            const fileName = fullFileName.substring(0, lastDotIndex);
            const extension = fullFileName.substring(lastDotIndex);
            return { fileName: fullFileName, extension }; // Return full filename with extension
        }
        
        return { fileName: fullFileName || 'downloaded_file', extension: '.log' };
    } catch (error) {
        console.error('Error parsing URL:', error);
        return { fileName: 'downloaded_file', extension: '.log' };
    }
};

    // Load data on mount or when pk/page changes
    useEffect(() => {
        fetchData(pk, pageno, limit);
    }, [pk, pageno, limit ,show]);

    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        setLimit(newPerPage);
        setPageNo(1); // Reset to first page
    };
    const conditionalRowStyles = [
   
           {
               when: (row,index) => {    return index % 2 == 0 || colorRow?.id == row?.id ? true : false },
               style: (row, index) => ({
                   backgroundColor: colorRow?.id == row.id ? '#dbf4f5' : '#f2f2f2',
               }),
           },
   
       ];

  

    
    const handleRowCheckClick = (row) => {
        data?.results?.map((item, index) => {
            if (row?.pk == item.pk) {
                setColorRow(row)
            }
        })
    }


    const columns = useMemo(
        () => [
            {
                id: "id",
                name: "S NO",
                selector: (row, index) =>
                    pageno === 1 ? index + 1 : (pageno - 1) * limit + index + 1,
                width: "80px",
                cell: (row, index) => (
                    <div>
                        {pageno === 1 ? index + 1 : (pageno - 1) * limit + index + 1}
                        {row?.is_error_occured && (
                            <i className="ms-2 blink blinking-text bi bi-exclamation-circle"></i>
                        )}
                    </div>
                ),
            },
            { name: "Client", selector: (row) => row.client, sortable: true },
            { name: "User", selector: (row) => row.user, sortable: true },
            { name: "Email Type", selector: (row) => row.email_type, sortable: true },
            {
                name: "Is Mail Sent",
                selector: (row) => (row.is_mail_sent ? "Yes" : "No"),
                sortable: true,
            },
            {
                name: "Email Log File",
                selector: (row) => row.emaillog_file,
                cell: (row) => (
                    <a href={`/${row.emaillog_file}`} target="_blank" rel="noreferrer">
                        {row.emaillog_file}
                    </a>
                ),
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    }>
                        {loadingRows[row?.id] ?
                            <div className="spinner-border spinner-border-sm " role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            :
                            //   <Tooltip disableInteractive title={row?.row.emaillog_file} placement='top' arrow >

                            <i onClick={() => handleDownloadSftpLog(row, "emaillog_file")} className="bi bi-download me-2 "></i>
                            //   </Tooltip>
                        }
                    </div>
                ,
            },
        ],
        [pageno, limit ,loadingRows]
    );
console.log(loadingRows,"loadingRows");

    return (
        <Modal show={show} onHide={onClose} dialogClassName="custom-modal-width" centered>
            <Modal.Header closeButton>
                <Modal.Title>Email Log</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                {loading ? (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ minHeight: 200 }}
                    >
                        <Spinner animation="border" />
                    </div>
                ) : (
                        <DataTable
                            className="custom-datatable"
                            fixedHeader
                            data={logData}
                            columns={columns}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            paginationPerPage={limit}
                            paginationRowsPerPageOptions={[25, 50, 100]}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            pointerOnHover
                             onRowClicked={handleRowCheckClick}
                            responsive
                            customStyles={queueDatatableCustomStyles}
                            conditionalRowStyles={conditionalRowStyles}
                        />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default EmailLog;
